import { createAction, props } from '@ngrx/store';
import { TimeEntryGridConfigModel } from 'app/core/mips/common/models/time-entry-grid-config.model';

export const setTimeEntryGridConfig = createAction('[TimeEntryGridConfig] Set TimeEntryGridConfig', props<{ timeEntryGridConfig: TimeEntryGridConfigModel }>());
export const clearTimeEntryGridConfig = createAction('[TimeEntryGridConfig] Clear TimeEntryGridConfig');